<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
      :title="page"
      icon="dashboard"
    ></vuse-section-definition>
    <v-container fluid class="home-content rounded-lg">
      <v-tabs v-model="tabIndex">
        <v-tab v-for="item in items" :key="item.id">{{ item.tab }}</v-tab>
      </v-tabs>
    </v-container>
    <v-container fluid class="home-content rounded-lg">
      <v-row  justify="center">
        <v-tabs-items v-model="tabIndex" class="min-width">
          <v-tab-item active class="">
            <banner-config></banner-config>
          </v-tab-item>
          <v-tab-item>
            <produc-category-config></produc-category-config>
          </v-tab-item>
          <v-tab-item>
            <post-config></post-config>
          </v-tab-item>
        </v-tabs-items>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import BannerConfig from "@/components/configs/banner_config";
import ProducCategoryConfig from "@/components/configs/product_category_config";
import PostConfig from "@/components/configs/post_config";
export default {
  components: {
    BannerConfig,
    ProducCategoryConfig,
    PostConfig
  },
  data() {
    return {
      tabIndex: 0,
      items: [
        {id: 0, tab: "Top banner"},
        // { id: 1, tab: "Countdown" },
        {id: 1, tab: "Danh mục sản phẩm"},
        {id: 2, tab: "Tin tức + Video"},
      ],
      page: "Home",
      breadcrumbs: [
        {
          text: "Home",
          disabled: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
    ]),
  },
  mounted() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "login" });
    }
  }
};
</script>
<style lang="scss">
.home-content {
  background: #ffffff !important;
}
.min-width {
  min-width: 90% !important;
}
</style>
